import { render, staticRenderFns } from "./activeDistribution.vue?vue&type=template&id=89e0ec9a&scoped=true"
import script from "./activeDistribution.vue?vue&type=script&lang=js"
export * from "./activeDistribution.vue?vue&type=script&lang=js"
import style0 from "./activeDistribution.vue?vue&type=style&index=0&id=89e0ec9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e0ec9a",
  null
  
)

export default component.exports